module.exports = __webpack_public_path__ + "img/user.46b81e60.jpg";